import React from 'react'
import { Spinner, Flex, Text } from '@chilipiper/design-system'
import { TimezoneSelect } from '@chilipiper/design-system/src/new'
import { useTranslations } from '../../../context/TranslationContext'
import { StyledBookMeetingContainer } from './styles'
import { ScheduleHeader } from './components/ScheduleHeader'

export const BookingFlowBlockLoading = ({
  state,
}: {
  state: 'scheduled' | 'scheduling' | undefined
}) => {
  const [loadingDatesAndTimes, loadingMeetingDetails] = useTranslations([
    'loadingDatesAndTimes',
    'loadingMeetingDetails',
  ])
  return (
    <StyledBookMeetingContainer>
      <TimezoneSelect
        isDisabled
        label={<TimezoneSelect.Label position='hidden'>Preferred timezone</TimezoneSelect.Label>}
        size='S'
        variant='nested'
        hasTime
      />
      {state && <ScheduleHeader state={state} />}
      <Flex p={7} my={1} justifyContent='center' alignItems='center'>
        <Spinner />
        <Text color='fg/moderate' ml={2} fontWeight={500}>
          {state === 'scheduled' ? loadingMeetingDetails : loadingDatesAndTimes}
        </Text>
      </Flex>
    </StyledBookMeetingContainer>
  )
}
